import { axiosGetHandler, axiosPostHandler } from "./config";
import { extractAPIValues } from "_lib/utils/utils";
const { BASE_API, BASE_XHH } = extractAPIValues();

// 获取正在游玩游戏的相关信息
export function getGameDisplayInfo(args) {
  const url = BASE_API + "/chatroom/v2/account/game_state/recommends";
  return axiosGetHandler(url, args);
}

// 获取游戏展示弹窗中的房间列表
export function getGameDisplayRoomList(args) {
  const url = BASE_API + "/chatroom/v2/account/recommend/room";
  return axiosGetHandler(url, args);
}

// 获取游戏展示弹窗中的小程序列表
export function getGameDisplayMpList(args) {
  const url = BASE_API + "/chatroom/v2/account/recommend/minipro";
  return axiosGetHandler(url, args);
}

// 获取游戏展示弹窗中的机器人列表
export function getGameDisplayBotList(args) {
  const url = BASE_API + "/chatroom/v2/account/recommend/bot";
  return axiosGetHandler(url, args);
}
